import React from "react";
import { letterGenderPhrases, parseLetterGender } from "./letterGenderUtils";
import sign from "./sign.png";
type OfferLetterProps = {
  date?: string;
  refNo?: string;
  candidateName?: string;
  address?: string;
  designation?: string;
  joiningDate?: string;
  pageNumber?: number;
  /** From onboarding; used for salutation (Mr./Ms.) on page 1 when known. */
  gender?: string | null;
};

const OfferLetter: React.FC<OfferLetterProps> = ({
  date = "19-08-2025",
  refNo = "Vic/25/Aug/19",
  candidateName = "Himani Gosavi",
  address = "No. 53, HustleHub, 5th Cross Rd, Near Sony World Signal,Koramangala, Bengaluru, Karnataka 560034",
  designation = "HR Recruiter Intern",
  joiningDate = "Aug 23, 2025",
  pageNumber = 1,
  gender = null,
}) => {
  const { honorific } = letterGenderPhrases(parseLetterGender(gender));
  const isFirstPage = pageNumber === 1;
  const isSecondPage = pageNumber === 2;
  const isThirdPage = pageNumber === 3;
  const isFourthPage = pageNumber === 4;
  const isFifthPage = pageNumber === 5;
  const isSixthPage = pageNumber === 6;
  const bulletRowClass = "flex items-start gap-2";
  const bulletIconClass = "w-4 shrink-0 text-center leading-[1.35]";
  const bulletTextClass = "flex-1";

  return (
    <div
      className="w-[794px] h-[1123px] overflow-hidden bg-white text-black shadow-sm p-8"
      style={{ boxSizing: "border-box", fontFamily: '"Times New Roman", serif' }}
    >
    
      <div className="w-full h-full flex flex-col" style={{ boxSizing: "border-box" }}>
        <div className="flex items-start justify-between border-b border-gray-300 pb-2">
          <div className="pt-0 self-start">
            <img
              src="/assets/images/earlyjobsCropped.png"
              alt="EarlyJobs"
              className="h-20 w-auto object-contain"
            />
          </div>
          <div className="max-w-[50%] text-left">
            <p className="text-xl font-bold text-[#1e355f]">Victa EarlyJobs Technologies Pvt. Ltd.</p>
            <p className="mt-1 text-sm text-gray-800 leading-snug">
              No. 53, HustleHub, 5th Cross Rd, Near Sony World Signal,Koramangala, Bengaluru, Karnataka 560034
            </p>
          </div>
        </div>

        <div className="mt-4 flex items-center justify-between text-base">
          <p>Dated: {date}</p>
          <p>Ref: - {refNo}</p>
        </div>

        <div className="mt-5 flex-1 flex flex-col">
        

          {isFirstPage ? (
            <div className="mt-3 space-y-1 text-[20px] leading-[1.28] p-[10px]">
               
              <p>
                <span className="font-semibold">Name:</span>{" "}
                {honorific ? `${honorific} ${candidateName}` : candidateName}
              </p>
              <p>
                <span className="font-semibold">Address:</span> {address}
              </p>
              <p className="font-semibold">Sub:- Offer Letter for Internship</p><br/>
              <p>
                Further to your interview at Victa Earlyjobs Technologies Pvt. Ltd, it is with pleasure that we
                extend the following offer of internship to you as an "{designation}". The details of the offer
                are enclosed and upon acceptance of the offer, you are requested to join our organization in
                Bangalore on or before {joiningDate}. Please find below the terms and conditions governing your
                internship at Victa Earlyjobs Technologies Pvt. Ltd
              </p>
              <br/>
              <div className="space-y-1 pl-2">
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>You would be based in India (Work Remotely) and are liable to be transferred to any other branch locations in any capacity when deemed necessary.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Your Stipend is as per Anexture II.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Appointment Letter will be provided after completing the joining formalities.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Office timing will be from 9:00 AM to 6:00 P.M.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Working days will be from Monday to Saturday.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Fixed week off is on Sunday.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>You shall agree to keep Victa Earlyjobs Technologies Pvt. Ltd informed in case of a change in your date of joining on account of any unforeseen events. However, the decision of the date change will be the sole privilege of Victa Earlyjobs Technologies Pvt. Ltd.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>You would be entitled to all benefits including leave as defined by the organization from time to time only after the completion of the probation period.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>You would be required to undertake travel for the organization’s work. You would be entitled to reimbursement of accommodation, boarding, travel, and conveyance expenses as applicable to your position.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>You would abide by the HR policies and guidelines of the organization as applicable.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Statutory deductions like Income tax, Professional tax, Provident fund etc., as applicable to your position from time to time, will be made while disbursing the remuneration every month.</p></div>
              </div>
            </div>
          ) : isSecondPage ? (
              <div className="mt-3 space-y-1 text-[20px] leading-[1.28] p-[10px]">
               
              <div className="space-y-1 pl-2">
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>The jurisdiction for any issues related to the breach of the offer shall be the city of Bangalore, Karnataka.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>You would not undertake business of similar nature with any other organization during the period of your employment with Victa Earlyjobs Technologies Pvt. Ltd.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>You are requested to submit photocopy of documents as mentioned in the Annexure I at the time of joining.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>This offer, if not accepted, will expire within 3 days from the date of offer. Please reply to the offer email as a token of your acceptance.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>You will be on probation for a period of Three months from the date of your joining. You will be considered for confirmation in the organization’s service if the organization is satisfied with reference to your overall work/performance and conduct during the period of probation. During your probation, Victaman or you can cease your employment by providing a one-day notice. If you have any queries about the probation and confirmation conditions you should make yourself clear with the management before joining.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>In the event of termination of services due to violation of organization policies, any breach of criminal proceedings and / or rules that may warrant disciplinary action and cause which includes, but is not limited to, any material breach of the Offer of employment or Code of Conduct by the employee, the Company would terminate the employee without any notice or explanation and pay in lieu thereof.</p></div>
              </div>

              <br/>
              <br/>
              
              <div className="flex flex-col items-end justify-end">
                <p>With Best Wishes, </p>
                <p>For Victa Earlyjobs Technologies Pvt. Ltd</p>
                <img src={sign} alt="sign" className="w-[40%] h-30 mt-1" />
                <p>Authorized Signatory</p>
                <p>Bangalore</p>
              </div>
            </div>
          ) : isThirdPage ? (
                <div className="mt-6 text-[20px] leading-relaxed p-[10px]">
                   
               <p className="pt-0.5">
                I have read, understood and accepted all the offer details. I understand that the terms and
                conditions listed are pre-conditions to my being offered employment with the organization. I am
                under no obligation to accept these terms and conditions of employment. I accept them of my own
                free choice and will. I opt for the following method as a token of commitment to my employability.
              </p>
              <div className="pt-0.5 space-y-0.5">
                <p>Name: ____________________</p>
                <p>Date: ____________________</p>
                <p>Signature: ____________________</p>
                <p>Place: ____________________</p>
              </div>

              <p className="text-center text-xl font-bold underline">Annexure I</p>
              <p>To enclose a photocopy of the below-mentioned documents:</p>
              <div className="space-y-1 pl-2">
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Graduation or post-graduation certificates and Mark sheets</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Birth Certificate / Proof of Age</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Passport size photographs</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Last employer’s offer letter, 3 months’ Pay slip from your previous employer (Optional)</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Any other Professional / Technical Certifications</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Any Government-issued valid ID Proof</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>PAN Card is mandatory</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Aadhar Card Copy mandatory</p></div>
              </div>
              <p className="pt-2">For further queries, please feel free to contact back to us.</p>
            </div>
          ) : isFourthPage ? (
            <div className="mt-6  text-[20px] leading-relaxed">
              
              <p className="text-center text-xl font-bold underline">Annexure II</p>
              <p className="font-semibold">Job role and responsibility:-</p>
              <p>
                Utilize various sourcing methods, including job portals, social media, professional networks, and
                referrals, to attract a diverse pool of candidates.
              </p>
              <div className="space-y-1 pl-2">
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Build and maintain a candidate pipeline for current and future job openings.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Review resumes and applications to assess qualifications and match them with job requirements.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Conduct telephonic interviews to evaluate candidates&apos; skills, experience, and cultural fit.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Schedule and coordinate interviews with candidates and hiring managers.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Provide candidates with information about the company and job details.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Collaborate with hiring managers to make informed hiring decisions.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Ensure a positive candidate experience throughout the recruitment process.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Provide timely feedback to candidates on their application status.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Maintain accurate records of all recruitment activities, including candidate interactions, interviews, and offers.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Ensure compliance with all relevant employment laws and regulations.</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Collaborate with HR and hiring managers to develop and refine the organization&apos;s talent acquisition strategy.</p></div>
              </div>
              
            </div>
          ) : isFifthPage ? (
            <div className="mt-6 text-[20px] leading-relaxed p-[10px]">
               
              <p className="text-center text-xl font-bold underline">Annexure II (Continued)</p>
              <p>Timing: - 9AM to 6PM  |  Age: - Above 18</p>
              <p>Qualification- Minimum Pursuing Graduation</p>
              <p>Internship Duration- Minimum 3 Months & Maximum 6 Months</p>
              <p>
                Overall, participating in an HR recruiter internship will be a valuable investment in your future
                career, providing opportunities for learning, growth, and professional development.
              </p>
              <p>At our company for Human Resources (HR) recruiter interns, we offer a range of benefits:</p>
              <div className="grid grid-cols-2 gap-x-6 gap-y-1 pl-2">
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Hands-On Experience</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Networking Opportunities</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Skill Development</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Resume Enhancement</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Exploration of Career Path</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Feedback and Evaluation</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Potential Job Offers</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Personal Growth</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Exposure to Industry Trends</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>Contributing to the Organization</p></div>
              </div>
              <p className="font-semibold pt-1">Stipend upon successful joining’s:-</p>
              <div className="space-y-1 pl-2">
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>0 to 4 - Nil</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>5 to 8 - 3000 INR</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>9 to 12 - 5000 INR</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>13 to 15 - 7500 INR</p></div>
                <div className={bulletRowClass}><span className={bulletIconClass}>•</span><p className={bulletTextClass}>16 or above - 10000 INR and Best Performer Awards</p></div>
              </div>
              <p className="font-semibold">Note:- Any interns should not ask for any money from any candidates.</p>
            </div>
          )   : (
            <div className="mt-6 flex-1" />
          )}

          <div className="mt-auto pt-6 flex justify-end">
            {/* <div className="w-[42%] text-left text-base leading-relaxed">
              <p>With Best Wishes,</p>
              <p>For Victa EarlyJobs Technologies Pvt. Ltd</p>

              <div className="mt-2 text-green-600 font-semibold flex items-left justify-left gap-2">
                <span>✔</span>
                <span>Digitally Signed</span>
              </div>

              <p className="text-sm text-gray-600 mt-1">
                Date: {new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}
              </p>

              <p>Bangalore</p>
            </div> */}
          </div>
        </div>

        <div className="mt-4 border-t border-dashed border-gray-300 pt-3 text-sm">
          <div className="flex items-center justify-between">
            <p>www.earlyjobs.in</p>
            <p>hr@earlyjobs.in</p>
            <p>+91 821 7527926</p>
          </div>
          <p className="mt-1 text-center text-[#d77a35]">Hire your ideal team.10X Quicker.</p>
        </div>
      </div>
    </div>
  );
};

export default OfferLetter;
